module.exports = __webpack_public_path__ + "img/jiangshilingmu.25bfb4ac.png";